import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Channel } from '../../../models/Support/SupportEnums';
import { PhoneIcon } from '../../../web/components/svgs/icons/PhoneIcon';
import { Pill } from '../../../web/components-v2/Pill';
import { THEME } from '../../../web/components-v2/Theme/theme';

const LABEL = 'Phone call';

const styleSheet = StyleSheet.create({
	// The compact form keeps the labelled pill's colors but drops to a glyph in a disc, so a ticket
	// row spends its width on the values that vary rather than on a word that repeats.
	compact: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		flex: 'none',
		width: 22,
		height: 22,
		borderRadius: '50%',
		border: `1px solid ${THEME.colors.pill.teal.border}`,
		backgroundColor: THEME.colors.pill.teal.background,
		color: THEME.colors.pill.teal.icon,
	},
});

interface TicketChannelBadgeProps {
	channel: Channel;
	/** Icon only, for a ticket row in a list. Detail surfaces have room for the label. */
	compact?: boolean;
}

export const TicketChannelBadge: React.FC<TicketChannelBadgeProps> = ({ channel, compact }) => {
	if (channel !== Channel.Phone) return null;

	if (compact) {
		return (
			<span className={css(styleSheet.compact)} role='img' aria-label={LABEL} title={LABEL}>
				<PhoneIcon width={12} height={12} fill='currentColor' aria-hidden />
			</span>
		);
	}

	return (
		<Pill
			variant='label'
			color='teal'
			size='small'
			label={LABEL}
			icon={<PhoneIcon width={12} height={12} fill='currentColor' aria-hidden />}
		/>
	);
};
